import { post } from "@/utils/utils";

const dataoke = {
  state: {},
  mutations: {
    TAOKE_ORDER_INFO_LIST() {},
    TAOKE_HANDLE_ORDER_LIST() {},
    TAOKE_AWAIT_HANDLE_ORDER_LIST() {},
    TAOKE_HANDLE_ORDER_INFO_LIST() {},
    TAOKE_HANDLE_ORDER() {}
  },
  actions: {
    taokeOrderInfoList({ commit }, params) {
      return post({
        commit,
        url: `/taoke/back/order/info`,
        name: "TAOKE_ORDER_INFO_LIST",
        params
      });
    },
    taokeHandleOrderList({ commit }, params) {
      return post({
        commit,
        url: `/taoke/back/handle_order/record`,
        name: "TAOKE_HANDLE_ORDER_LIST",
        params
      });
    },
    taokeAwaitHandleOrderList({ commit }, params) {
      return post({
        commit,
        url: `/taoke/back/wait_handle_order/info`,
        name: "TAOKE_AWAIT_HANDLE_ORDER_LIST",
        params
      });
    },
    taokeHandleOrderInfoList({ commit }, params) {
      return post({
        commit,
        url: `/taoke/back/handle_order/info`,
        name: "TAOKE_HANDLE_ORDER_INFO_LIST",
        params
      });
    },
    taokeHandleOrder({ commit }, params) {
      return post({
        commit,
        url: `/taoke/back/handle_order`,
        name: "TAOKE_HANDLE_ORDER",
        params
      });
    }
  }
};

export default dataoke;
